import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

const featuredWorks = articles.filter((a) => a.category === "works").slice(0, 3);

export default function FeaturedWorks() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-xs tracking-[0.2em] text-primary-500 mb-2 font-medium">
              精选作品
            </p>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950">
              经典作品回顾
            </h2>
          </div>
          <Link
            to="/category/works"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredWorks.map((work) => (
            <Link
              key={work.id}
              to={`/article/${work.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-50 transition-all duration-300"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={work.coverImage}
                  alt={work.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-primary-100 text-primary-600 px-2 py-0.5 rounded-full whitespace-nowrap">
                    作品集
                  </span>
                  <span className="text-xs text-foreground-500">{work.date}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {work.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2">
                  {work.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {work.views.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-line"></i> {work.likes.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/works"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部作品 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}